import * as React from "react";
const SvgOrderArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 36, viewBox: "0 0 16 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 34.5V1M1.25 28L8 34.75L14.75 28", stroke: "#747474", style: {
  stroke: "#747474",
  stroke: "color(display-p3 0.4542 0.4542 0.4542)",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgOrderArrow;
